import axios from 'axios';
import Errors from './Errors';

export default {
  data() {
    return {
      baseUrl: '',
      userId: null,
    };
  },
  async getRole(id) {
    try {
      const { data } = await axios.get(`${this.baseUrl}Roles/${id}`);
      return [null, data];
    } catch (error) {
      Errors.onError(error);
      return [error];
    }
  },
  async get() {
    try {
      const { data } = await axios.get(`${this.baseUrl}Roles`, {
        headers: {
          'Content-Type': 'application/json',
          'User-Id': this.userId,
        },
      });
      return [null, data];
    } catch (error) {
      Errors.onError(error);
      return [error];
    }
  },
};
